

























































import {IStudy} from "@/shared/models/api/study-choice-studies-model"
import {defineComponent, PropType} from '@vue/composition-api'
import {useActions, useGetters} from "vuex-composition-helpers"

import TitleAtom from "@/shared/components/atoms/card/TitleAtom.vue"
import ActionAtom from "@/shared/components/atoms/card/ActionAtom.vue"
import ButtonLinkAtom from "@/shared/components/atoms/card/ButtonLinkAtom.vue"

export default defineComponent({
    name: "FavoriteStudy",
    components: {
        TitleAtom,
        ActionAtom,
        ButtonLinkAtom
    },
    props: {
        study: {
            type: [] as PropType<IStudy>,
            required: true,
            default: ""
        }
    },
    setup: () => {
        const {config} = useGetters(['config']);
        const {deleteStudyChoiceFavorite} = useActions(['deleteStudyChoiceFavorite']);

        const deleteAsFavorite = async (id: number) => {
            await deleteStudyChoiceFavorite(id);
        }
        
        return {config, deleteAsFavorite}
    }
})
